// ERRORS USED BY APIWRAP

// BRINKS TO "SOMETHING WENT WRONG" PAGE
export class ApiError extends Error {
  constructor(message, options) {
    super(message, {
      cause: JSON.stringify(options ?? {}),
    });
  }

  get exceptionCause() {
    return JSON.parse(this.cause);
  }

  toString() {
    return `${this.name}: ${this.message} ${this.cause}`;
  }
}

// SHOWS A TOAST
export class NotifyApiError extends ApiError {
  constructor(message, options) {
    super(message, {
      ...options ?? {},
      notify: true,
    });
  }
}

export default ApiError;
